/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum MatchOperationV2ShotOutcome {
    Goal = 'GOAL',
    Saved = 'SAVED',
    Missed = 'MISSED',
    Post = 'POST',
    Blocked = 'BLOCKED'
}


export function instanceOfMatchOperationV2ShotOutcome(value: any): boolean {
    for (const key in MatchOperationV2ShotOutcome) {
        if (Object.prototype.hasOwnProperty.call(MatchOperationV2ShotOutcome, key)) {
            if (MatchOperationV2ShotOutcome[key as keyof typeof MatchOperationV2ShotOutcome] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MatchOperationV2ShotOutcomeFromJSON(json: any): MatchOperationV2ShotOutcome {
    return MatchOperationV2ShotOutcomeFromJSONTyped(json, false);
}

export function MatchOperationV2ShotOutcomeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationV2ShotOutcome {
    return json as MatchOperationV2ShotOutcome;
}

export function MatchOperationV2ShotOutcomeToJSON(value?: MatchOperationV2ShotOutcome | null): any {
    return value as any;
}

export function MatchOperationV2ShotOutcomeToJSONTyped(value: any, ignoreDiscriminator: boolean): MatchOperationV2ShotOutcome {
    return value as MatchOperationV2ShotOutcome;
}

